import { CommonCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import StepFromAnsc from 'civil-status/pages/step-from-ansc';
import { ReactElement } from 'react';

const PageDetailNotificationsAnscOperator = (): ReactElement => {
  return (
    <StepFromAnsc
      baseUrl="/stato-civile/notifiche/ansc/ricerca/operatore"
      items={[
        ...CommonCivilStatusCrumbs,
        {
          name: 'Gestione notifiche ANSC',
          path: '/stato-civile/notifiche/ansc/ricerca/operatore',
        },
        {
          name: 'Visualizza atto',
          path: '',
        },
      ]}
      isNotificationsAnsc
    />
  );
};

PageDetailNotificationsAnscOperator.displayName =
  'Page detail Notifications Ansc Operator component';

export default PageDetailNotificationsAnscOperator;
